import { TOrgConfig } from "@eventr/common";

/** `chatEligibility` when the server sends it, otherwise `isRocketChatInitialised`. */
export const isChatAvailable = (config: TOrgConfig | undefined): boolean => {
  if (!config) return false;
  if (config.chatEligibility) return config.chatEligibility.eligible;
  return config.isRocketChatInitialised === true;
};

export const hasChatEligibility = (config: TOrgConfig | undefined): boolean => !!config?.chatEligibility;
